/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-用户管理-pgc用户信息
 */
'use strict';
angular.module("pgcUserInformationModule", ['pgcUserInformationServiceModule']).
controller('pgcUserInformationCtrl', ['$scope', 'pgcUserInformationService', 'httpService','$q','$timeout','modalDialog', function($scope, pgcUserInformationService, httpService,$q,$timeout,modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions:[],
        }
        $scope.page = {
            "CURRPAGE": 0,
            "PAGESIZE": 20,
            "ITEMCOUNT": 2000
        };
        $scope.allMediaType = {
	    	0: '个人',
	        1: '媒体',
	        2: '国家机构',
	        3: '企业',
	        4: '其他组织'
	    };
        $scope.data = {
            listData: [],
            keywords: "", //检索的关键词
            selectedArray: [], //选中的数据
        };
    };

    function initData() {
    	initChannelsList().then(function() {
    		initDropDownList();
		    requestData();
        })
    };
    
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectUser = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    
    /**
     * [selectPanel description] 删除用户
     * @param  {[type]} userIds [description] 用户id串
     */
    $scope.deleteUsers = function() {
        modalDialog.backConfirmModal("删除用户", "确认删除当前选中的用户?", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/pgcuser/delete.do", params, "post").then(function(data) {
            	modalDialog.alertType('','删除成功','success');
                requestData();
            });
        });
    };
    /**
     * [selectPanel description] 停用用户
     * @param  {[type]} userIds [description] 用户id串
     */
    $scope.closeUsers = function() {
        modalDialog.backConfirmModal("停用用户", "确认停用当前选中的用户?", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/pgcuser/disable.do", params, "post").then(function(data) {
            	modalDialog.alertType('','停用成功','success');
                requestData();
            });
        });
    };
    
    /**
     * [selectPanel description] 启用用户
     * @param  {[type]} userIds [description] 用户id串
     */
    $scope.openUsers = function() {
        modalDialog.backConfirmModal("启用用户", "确认启用当前选中的用户?", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/pgcuser/enable.do", params, "post").then(function(data) {
            	modalDialog.alertType('','启用成功','success');
                requestData();
            });
        });
    };
    
    /**
     * [selectPanel description] 导出用户
     * @param  {[type]} userIds [description] 用户id串
     */
    $scope.exportUsers = function() {
    	var o = $scope.status;
    	var status = o.selectedStatus.value;
    	var mediaType = o.selectedTypeStatus.value;
    	var channelId = o.selectedchannels.value;
    	var startTime = o.startDate == undefined ? "":o.startDate;
    	var endTime = o.endDate == undefined ? "":o.endDate;
    	var searchword = $scope.data.keywords;
        var params ="status="+status+
        			"&mediaType="+mediaType+
        			"&channelId="+channelId+
        			"&startTime="+startTime+
        			"&endTime="+endTime+
        			"&searchword="+searchword;
        var url = "/mcnadmin/admin/pgcuser/exportExcel.do?"+params;
        modalDialog.backConfirmModal("导出", "是否导出所有用户？", function() {
        	window.open(url);
        });
    };
    /**
     * [fullTextSearch description;全文检索]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    };
    
    /**
     * [roleSetting description] 角色设置
     * @param  {[type]} userIds [description] 用户id串
     */
    $scope.roleSetting = function(userId){
    	pgcUserInformationService.roleSetting(userId).then(function(data) {
    		var params = {
    			userId:userId,
    			roleIds:data
    		}
            httpService.http("/mcnadmin/admin/pgcuser/roleSet.do", params, "post").then(function(data) {
            	modalDialog.alertType("","设置角色成功", "success");
                requestData();
            });
        });
    }
    /**
     * [pgcUserDetails description] -用户详细信息
     * @return {[type]} [description]
     */
    $scope.pgcUserDetails = function(userId) {
        pgcUserInformationService.pgcUserDetails(userId).then(function(data) {
            console.log(data);
        });
    };
    /**
     * [editUser description] -用户编辑
     * @return {[type]} [description]
     */
    $scope.editUser = function(userId) {
        pgcUserInformationService.editUser(userId).then(function() {
            requestData();
            modalDialog.alertType('','用户编辑成功','success');
            // httpService.http("/mcnadmin/admin/pgcuser/edit.do", data, "post").then(function(data) {
            	
    		// 	requestData();
            // });
        });
    };
    /**
     * channelView
     * @param {用户id} id 
     */
    $scope.channelView=function(id){
        httpService.http('/mcnadmin//admin/pgcuser/findUserChannels.do',{id:id},'post').then(function(res){
            if(res.data.length==0){
                modalDialog.alertType('', '渠道管理失败该用户下没有可操作的渠道', 'warning', 'confirm');
            }else{
                pgcUserInformationService.channelManagement(id).then(function(){
                    debugger;
                    modalDialog.alertType('', '删除成功', 'success');
                    requestData();
                });
            }
        })
        // httpService.http('/mcnadmin//admin/pgcuser/findUserChannels.do',{id:id},'post').then(function(res){
        //     if(res.data.length==0){
        //         // pgcUserInformationService.noTips('渠道管理失败','该用户下没有可操作的渠道');
        //         modalDialog.alertType('','渠道管理失败该用户下没有可操作的渠道','warning','confirm');
        //     }else{
            // modalDialog.alertType('', '渠道管理失败该用户下没有可操作的渠道', 'warning', 'confirm');
               
            //     });
            // }
            //     modalDialog.alertType('','渠道管理失败该用户下没有可操作的渠道','warning',true,'',false,true);
            // // }
        // })
    }
    /**
     * [createProduct description] 初始化数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
	
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.statusOptions = [{
            name: "全部状态",
            value: ''
        }, {
            name: "正常",
            value: 0
        }, {
            name: "停用",
            value: 1,
        }];
        $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
        $scope.status.typeOptions = [{
            name: "全部类型",
            value: ''
        }, {
            name: '个人',
            value: 0
        }, {
            name: '媒体',
            value: 1
        }, {
            name: '国家机构',
            value: 2
        }, {
            name: '企业',
            value: 3
        }, {
            name: '其他组织',
            value: 4
        }];
        $scope.status.selectedTypeStatus = angular.copy($scope.status.typeOptions[0]);
    };
    /**
     * [initChannelsList description] 初始化渠道
     * @return {[type]} [description]
     */
    function initChannelsList() {
        var deferred = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getAuthChannels.do", "", "post").then(function(data) {
        	var item = data.data;
            var allchannel = {
                name: "全部渠道",
                value: ''
            }
            $scope.status.channelsOptions.push(allchannel);
            for (var i = 0; i < item.length; i++) {
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedchannels = angular.copy($scope.status.channelsOptions[0]);
            deferred.resolve();
        })
        return deferred.promise;
    }
    /**
     * [requestData description] 初始化列表
     * @return {[type]} [description]
     */
    function requestData() {
        var params = {
            status: $scope.status.selectedStatus.value,
            mediaType: $scope.status.selectedTypeStatus.value,
            channelId: $scope.status.selectedchannels.value,
            startTime: $scope.status.startDate,
            endTime: $scope.status.endDate,
            searchword: $scope.data.keywords,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        }
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/list.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
            $scope.data.selectedArray = [];
        });
    };
}]);
